import { AssetType } from "@vviinn/user-managment-client-ts";

const assetTypes: AssetType[] = ["css", "svg", "png", "webp", "jpg", "csv"];

export const acceptableFileFormats: string = assetTypes
  .map((type) => `.${type}`)
  .join(", ");
